import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { ShieldCheck, Loader2, AlertTriangle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [state, setState] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    if (!sessionId) { setState("error"); return; }
    let cancelled = false;
    const poll = async () => {
      if (cancelled || attempts.current >= 10) { if (!cancelled) setState("timeout"); return; }
      attempts.current += 1;
      try {
        const res = await axios.get(`${API}/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") { setState("paid"); return; }
        if (["failed", "expired"].includes(res.data.payment_status)) { setState("error"); return; }
      } catch { /* keep polling */ }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="bg-[#05071F] min-h-screen flex items-center justify-center font-body px-6">
      <div data-testid="payment-success-card" className="w-full max-w-md border border-white/10 bg-[#0B1035] p-10 text-center text-white">
        {state === "checking" && (<><Loader2 className="w-10 h-10 text-cyan-400 mx-auto animate-spin" />
          <h1 className="mt-6 font-heading text-2xl font-medium">Confirming your payment…</h1>
          <p className="mt-3 text-sm text-slate-400">Please don't close this window.</p></>)}
        {state === "paid" && (<><ShieldCheck className="w-10 h-10 text-emerald-400 mx-auto" />
          <h1 data-testid="payment-confirmed" className="mt-6 font-heading text-2xl font-medium">Payment confirmed</h1>
          <p className="mt-3 text-sm text-slate-400">Thank you — a receipt has been emailed to you. Our team will follow up shortly.</p></>)}
        {(state === "error" || state === "timeout") && (<><AlertTriangle className="w-10 h-10 text-amber-400 mx-auto" />
          <h1 className="mt-6 font-heading text-2xl font-medium">{state === "timeout" ? "Still processing" : "Payment issue"}</h1>
          <p className="mt-3 text-sm text-slate-400">{state === "timeout"
            ? "Your payment is taking longer than expected. If you completed checkout, you'll receive a receipt by email."
            : "We couldn't confirm this payment. If you were charged, contact janthony@silentsentrycorp.com."}</p></>)}
        <Link to="/" className="mt-8 inline-block text-sm text-cyan-400 hover:text-cyan-300 transition-colors">← Back to Silent Sentry</Link>
      </div>
    </div>
  );
}
